/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */


/**
 * The category of energy:
 *   * ELECTRICITY
 *   * HYDROGEN
 *   * GAS
 *   * WATER
 *   * UNDEFINED
 */
export enum EnergyCategory {
  ELECTRICITY = 'ELECTRICITY',
  HYDROGEN = 'HYDROGEN',
  GAS = 'GAS',
  WATER = 'WATER',
  UNDEFINED = 'UNDEFINED'
}
